var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('strong',[_vm._v(" USUARIO NO AUTHORIZADO ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }